module.exports = __webpack_public_path__ + "img/22.e44bd8a7.webp";